import React, { ReactNode } from 'react'
import './document.css';

interface Props {
    classes? : string;
    children : ReactNode;
}

export class Document extends React.Component<Props> {

    getClasses() : string
    {
        if (this.props.classes) {
            return "document " + this.props.classes;
        }
        else {
            return "document";
        }
    }

    render() {
        return (
            <div className={ this.getClasses() }>
                { this.props.children }
            </div>
        )
    }
}

